import { useState} from "react";
import styles from './searchData.module.css'
import TEXT from "localisation/";
import globalStyles from '../search.module.css';
type RecommendationProps = {
  id: number;
  uri: string;
  name: string;
  textLabel: string;
  doc_count: number;
  forSale: boolean;
};
/** Individual recommendation for nearby towns, ie: Shops to rent in Guildford */
const Recommendation = ({ uri, name, textLabel = 'PROPERTY', doc_count, forSale = false }: RecommendationProps) => {
  return (
    <li>
      <a href={`/${TEXT[`${textLabel}_URI${forSale ? '_FOR_SALE' : ''}`] || 'shops-to-rent'}/${uri}`} >{`${name} (${doc_count})`}</a>
    </li>
  );
};

/** Recommendations for nearby towns
 * @returns a list of Recommendation components
 */
const Recommendations = ({ recommendations, searchType, categoryCode, name, forSale }) => {
  const [showAll, setShowAll] = useState(false);
  let textLabel = `${searchType}_${categoryCode}`

  const groupByCategory = recommendations.reduce((group, recommendation) => {
    const { to } = recommendation;
    group[to] = group[to] ?? [];
    group[to].push(recommendation);
    return group;
  }, {});
  const numberToShow = 2;
  const length = Object.keys(groupByCategory).length
  if (recommendations && recommendations.length <= 0) return null;
  return (
    <>
      <h2 className={styles.heading} style={{ 'marginBottom': '15px' }}>Nearby locations with available shops</h2>
      <section className={styles.recomendationContainer}>
        {Object.keys(groupByCategory).map((id, index) => {
          const data = groupByCategory[id];
          return (
            <div key={id} className={index > (showAll ? length : numberToShow) ? `${styles.recomendationGroup} ${styles.hide}` : styles.recomendationGroup}>
              <p>{`Shops ${forSale ? 'for sale' : 'to rent'} within  ${id} miles`}</p>
              <ul>
                {data.map((props: RecommendationProps) => (
                  <Recommendation key={props.id} {...props} textLabel={textLabel} forSale={forSale} />
                ))}
              </ul>
            </div>
          )
        })}
      </section>
      {length > numberToShow && (
          <button
          className={`${globalStyles.primaryButton} ${styles.locationsButton}`}
            onClick={() => {
              setShowAll(!showAll);
            }}
          >{`Show ${showAll ? "fewer" : "more"} locations`}</button>
        )}

    </>
  )
};

export default Recommendations;
